import { render, staticRenderFns } from "./dayclosureuser.vue?vue&type=template&id=38f279fc&"
import script from "./dayclosureuser.vue?vue&type=script&lang=js&"
export * from "./dayclosureuser.vue?vue&type=script&lang=js&"
import style0 from "./dayclosureuser.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports